import { API_CONFIG } from './apiConfig';

/**
 * Validate file before upload
 * @param {File} file - The file to validate
 * @returns {Object} - { isValid: boolean, error: string | null }
 */
export const validateFile = (file) => {
  if (!file) {
    return {
      isValid: false,
      error: 'No file provided',
      errorType: 'NO_FILE',
    };
  }

  // Check file type
  const isValidType = API_CONFIG.FILE_VALIDATION.ALLOWED_TYPES.includes(file.type);
  const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
  const isValidExtension = API_CONFIG.FILE_VALIDATION.ALLOWED_EXTENSIONS.includes(fileExtension);

  if (!isValidType && !isValidExtension) {
    return {
      isValid: false,
      error: "This file type isn't supported",
      errorType: 'INVALID_TYPE',
    };
  }

  // Check file size
  if (file.size > API_CONFIG.FILE_VALIDATION.MAX_SIZE) {
    return {
      isValid: false,
      error: 'Plan size unsupported. Upload under 10 MB',
      errorType: 'FILE_TOO_LARGE',
    };
  }

  return {
    isValid: true,
    error: null,
    errorType: null,
  };
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export default validateFile;
